/**
 * Outbound link notice — passive affiliate/third-party disclosure shown as the user leaves
 * for a marketplace. It never blocks or delays the navigation; the binding disclaimer lives
 * in the Terms of Service (Section 11) and the footer commission disclosure.
 */

const NOTICE_ID = 'outboundNotice';
const VISIBLE_MS = 6000;

let hideTimer = null;

function marketplaceLabel(url) {
  const target = String(url || '').toLowerCase();
  if (target.includes('ebay')) return 'eBay';
  if (target.includes('amazon')) return 'Amazon';
  return 'the seller’s site';
}

function getNoticeElement() {
  let el = document.getElementById(NOTICE_ID);
  if (el) return el;

  el = document.createElement('div');
  el.id = NOTICE_ID;
  el.className = 'outbound-notice';
  // Announced, but never focus-stealing: the user has already moved on to the new tab.
  el.setAttribute('role', 'status');
  el.setAttribute('aria-live', 'polite');
  document.body.appendChild(el);
  return el;
}

/**
 * Show the outbound notice for a marketplace URL. Safe to call on every outbound click.
 * @param {string} targetUrl - The external URL the user is being sent to
 */
export function showOutboundNotice(targetUrl = '') {
  try {
    if (typeof document === 'undefined' || !document.body) return;

    const el = getNoticeElement();
    el.innerHTML = '';

    const text = document.createElement('span');
    text.textContent = `Opening ${marketplaceLabel(targetUrl)}. Sales are handled by the marketplace; UsedFindr may earn a commission. `;
    el.appendChild(text);

    // Same path under both the Vite dev tree and the Django route (urls.py: name='terms').
    const link = document.createElement('a');
    link.href = '/terms.html';
    link.textContent = 'Terms';
    link.target = '_blank';
    link.rel = 'noopener noreferrer';
    el.appendChild(link);

    // Restart the transition even when a previous notice is still on screen.
    window.clearTimeout(hideTimer);
    el.classList.remove('is-visible');
    // Flush the hidden state synchronously so the transition replays. requestAnimationFrame
    // would be the usual choice but does not fire while the tab is backgrounded, and
    // window.open has just put this tab behind the marketplace one.
    void el.offsetWidth;
    el.classList.add('is-visible');
    hideTimer = window.setTimeout(() => el.classList.remove('is-visible'), VISIBLE_MS);
  } catch (e) {
    // A disclosure that fails to render must never stop the outbound click.
  }
}
